/**
 * * Raisin's microservices base URLs based on request region and environment
 *
 * - You can find all configuration listed here:
 *   https://raisin-jira.atlassian.net/wiki/spaces/RXTS/pages/2443837548
 *
 * - Structure: `service` > `region` > `environment` > `base-url`
 *
 * - `CPS`, `UMS`, `CAS`, `WJIS`, `SCAS`, `TAMS`, etc...
 *
 * - External API Gateway
 *   https://raisin-jira.atlassian.net/wiki/spaces/SRE/pages/2278949354/External+API+Gateway
 *
 * - Internal API Gateway
 *   https://raisin-jira.atlassian.net/wiki/spaces/SRE/pages/1659503729/Internal+API+Gateway
 *
 * - We should use only external APIs in `Customer-Portal`,
 *   in some cases external APIs are not exposed to public consumption for sometime,
 *   then for development purposes we can use internal APIs in `local`, `development` and `staging` environments
 */

const microservices = {
  wjis: {
    gbr: {
      local: 'https://api2.dev-raisin.com/wjis',
      development: 'https://api2.dev-raisin.com/wjis',
      staging: 'https://api2.staging-raisin.com/wjis',
      onboarding: 'https://api2.onboarding-raisin.com/wjis',
      production: 'https://api2.raisin.com/wjis',
    },
    deu: {
      local: 'https://api2.dev-raisin.com/wjis',
      development: 'https://api2.dev-raisin.com/wjis',
      staging: 'https://api2.staging-raisin.com/wjis',
      onboarding: 'https://api2.onboarding-raisin.com/wjis',
      production: 'https://api2.raisin.com/wjis',
    },
  },
  ums: {
    gbr: {
      local: 'https://api2.dev-raisin.co.uk/ums/v1',
      development: 'https://api2.dev-raisin.co.uk/ums/v1',
      staging: 'https://api2.staging-raisin.co.uk/ums/v1',
      onboarding: 'https://api2.onboarding-raisin.co.uk/ums/v1',
      production: 'https://api2.raisin.co.uk/ums/v1',
    },
    deu: {
      local: 'https://api2.dev-weltsparen.de/ums/v1',
      development: 'https://api2.dev-weltsparen.de/ums/v1',
      staging: 'https://api2.staging-weltsparen.de/ums/v1',
      onboarding: 'https://api2.onboarding-weltsparen.de/ums/v1',
      production: 'https://api2.weltsparen.de/ums/v1',
    },
  },
  cas: {
    mock: 'http://localhost:9000/cas/public/v1',
    gbr: {
      local: 'https://api2.dev-raisin.co.uk/cas/public/v1',
      development: 'https://api2.dev-raisin.co.uk/cas/public/v1',
      staging: 'https://api2.staging-raisin.co.uk/cas/public/v1',
      onboarding: 'https://api2.onboarding-raisin.co.uk/cas/public/v1',
      production: 'https://api2.raisin.co.uk/cas/public/v1',
    },
    deu: {
      local: 'https://api2.dev-weltsparen.de/cas/public/v1',
      development: 'https://api2.dev-weltsparen.de/cas/public/v1',
      staging: 'https://api2.staging-weltsparen.de/cas/public/v1',
      onboarding: 'https://api2.onboarding-weltsparen.de/cas/public/v1',
      production: 'https://api2.weltsparen.de/cas/public/v1',
    },
  },
  cts: {
    requestTimeout: 20000,
    mock: 'http://localhost:8080',
    gbr: {
      local: 'https://api2.dev-raisin.co.uk/cts/public',
      development: 'https://api2.dev-raisin.co.uk/cts/public',
      staging: 'https://api2.staging-raisin.co.uk/cts/public',
      onboarding: 'https://api2.onboarding-raisin.co.uk/cts/public',
      production: 'https://api2.raisin.co.uk/cts/public',
    },
    deu: {
      local: 'https://api2.dev-weltsparen.de/cts/public',
      development: 'https://api2.dev-weltsparen.de/cts/public',
      staging: 'https://api2.staging-weltsparen.de/cts/public',
      onboarding: 'https://api2.onboarding-weltsparen.de/cts/public',
      production: 'https://api2.weltsparen.de/cts/public',
    },
  },
  scas: {
    gbr: {
      local: 'https://api2.dev-raisin.co.uk/scas/api/v2',
      development: 'https://api2.dev-raisin.co.uk/scas/api/v2',
      staging: 'https://api2.staging-raisin.co.uk/scas/api/v2',
      onboarding: 'https://api2.onboarding-raisin.co.uk/scas/api/v2',
      production: 'https://api2.raisin.co.uk/scas/api/v2',
    },
    deu: {
      local: 'https://api2.dev-weltsparen.de/scas/api/v2',
      development: 'https://api2.dev-weltsparen.de/scas/api/v2',
      staging: 'https://api2.staging-weltsparen.de/scas/api/v2',
      onboarding: 'https://api2.onboarding-weltsparen.de/scas/api/v2',
      production: 'https://api2.weltsparen.de/scas/api/v2',
    },
  },
  cps: {
    mock: 'http://localhost:9000/cps/api/v1',
    gbr: {
      local: 'https://api2.dev-raisin.co.uk/cps/api/v1',
      development: 'https://api2.dev-raisin.co.uk/cps/api/v1',
      staging: 'https://api2.staging-raisin.co.uk/cps/api/v1',
      onboarding: 'https://api2.onboarding-raisin.co.uk/cps/api/v1',
      production: 'https://api2.raisin.co.uk/cps/api/v1',
    },
    deu: {
      local: 'https://api2.dev-weltsparen.de/cps/api/v1',
      development: 'https://api2.dev-weltsparen.de/cps/api/v1',
      staging: 'https://api2.staging-weltsparen.de/cps/api/v1',
      onboarding: 'https://api2.onboarding-weltsparen.de/cps/api/v1',
      production: 'https://api2.weltsparen.de/cps/api/v1',
    },
  },
  tams: {
    gbr: {
      local: 'https://api2.dev-raisin.co.uk/tams/v1',
      development: 'https://api2.dev-raisin.co.uk/tams/v1',
      staging: 'https://api2.staging-raisin.co.uk/tams/v1',
      onboarding: 'https://api2.onboarding-raisin.co.uk/tams/v1',
      production: 'https://api2.raisin.co.uk/tams/v1',
    },
    deu: {
      local: 'https://api2.dev-weltsparen.de/tams/v1',
      development: 'https://api2.dev-weltsparen.de/tams/v1',
      staging: 'https://api2.staging-weltsparen.de/tams/v1',
      onboarding: 'https://api2.onboarding-weltsparen.de/tams/v1',
      production: 'https://api2.weltsparen.de/tams/v1',
    },
  },
  keycloak: {
    gbr: {
      local: 'https://auth-gbr-development.raisin-dev.network/auth/realms/global',
      development: 'https://auth-gbr-development.raisin-dev.network/auth/realms/global',
      staging: 'https://auth.staging-raisin.co.uk/auth/realms/global',
      onboarding: 'https://auth.onboarding-raisin.co.uk/auth/realms/global',
      production: 'https://auth.raisin.co.uk/auth/realms/global',
    },
    deu: {
      local: 'https://auth-deu-development.raisin-dev.network/auth/realms/global',
      development: 'https://auth-deu-development.raisin-dev.network/auth/realms/global',
      staging: 'https://auth.staging-weltsparen.de/auth/realms/global',
      onboarding: 'https://auth.onboarding-weltsparen.de/auth/realms/global',
      production: 'https://auth.weltsparen.de/auth/realms/global',
    },
  },
  cpms: {
    gbr: {
      local: 'https://api2.dev-raisin.co.uk/cpms/public/v1',
      development: 'https://api2.dev-raisin.co.uk/cpms/public/v1',
      staging: 'https://api2.staging-raisin.co.uk/cpms/public/v1',
      onboarding: 'https://api2.onboarding-raisin.co.uk/cpms/public/v1',
      production: 'https://api2.raisin.co.uk/cpms/public/v1',
    },
    deu: {
      local: 'https://api2.dev-weltsparen.de/cpms/public/v1',
      development: 'https://api2.dev-weltsparen.de/cpms/public/v1',
      staging: 'https://api2.staging-weltsparen.de/cpms/public/v1',
      onboarding: 'https://api2.onboarding-weltsparen.de/cpms/public/v1',
      production: 'https://api2.weltsparen.de/cpms/public/v1',
    },
  },
  dds: {
    mock: 'http://localhost:9000/dds/api/v2',
    gbr: {
      local: 'https://api2.dev-raisin.co.uk/dds/api/v2',
      development: 'https://api2.dev-raisin.co.uk/dds/api/v2',
      staging: 'https://api2.staging-raisin.co.uk/dds/api/v2',
      onboarding: 'https://api2.onboarding-raisin.co.uk/dds/api/v2',
      production: 'https://api2.raisin.co.uk/dds/api/v2',
    },
    deu: {
      local: 'https://api2.dev-weltsparen.de/dds/api/v2',
      development: 'https://api2.dev-weltsparen.de/dds/api/v2',
      staging: 'https://api2.staging-weltsparen.de/dds/api/v2',
      onboarding: 'https://api2.onboarding-weltsparen.de/dds/api/v2',
      production: 'https://api2.weltsparen.de/dds/api/v2',
    },
  },
  kci: {
    mock: 'http://localhost:9000/kci/api/v1',
    gbr: {
      local: 'https://api2.dev-raisin.co.uk/kci/api/v1',
      development: 'https://api2.dev-raisin.co.uk/kci/api/v1',
      staging: 'https://api2.staging-raisin.co.uk/kci/api/v1',
      onboarding: 'https://api2.onboarding-raisin.co.uk/kci/api/v1',
      production: 'https://api2.raisin.co.uk/kci/api/v1',
    },
    deu: {
      local: 'https://api2.dev-weltsparen.de/kci/api/v1',
      development: 'https://api2.dev-weltsparen.de/kci/api/v1',
      staging: 'https://api2.staging-weltsparen.de/kci/api/v1',
      onboarding: 'https://api2.onboarding-weltsparen.de/kci/api/v1',
      production: 'https://api2.weltsparen.de/kci/api/v1',
    },
  },
  kss: {
    mock: 'http://localhost:9000/kss/api/v1',
    gbr: {
      local: 'https://api2.dev-raisin.co.uk/kss/api/v1',
      development: 'https://api2.dev-raisin.co.uk/kss/api/v1',
      staging: 'https://api2.staging-raisin.co.uk/kss/api/v1',
      onboarding: 'https://api2.onboarding-raisin.co.uk/kss/api/v1',
      production: 'https://api2.raisin.co.uk/kss/api/v1',
    },
    deu: {
      local: 'https://api2.dev-weltsparen.de/kss/api/v1',
      development: 'https://api2.dev-weltsparen.de/kss/api/v1',
      staging: 'https://api2.staging-weltsparen.de/kss/api/v1',
      onboarding: 'https://api2.onboarding-weltsparen.de/kss/api/v1',
      production: 'https://api2.weltsparen.de/kss/api/v1',
    },
  },
  kcps: {
    mock: 'http://localhost:9000/kcps/api/v1',
    gbr: {
      local: 'https://api2.dev-raisin.co.uk/kcps/api/v1',
      development: 'https://api2.dev-raisin.co.uk/kcps/api/v1',
      staging: 'https://api2.staging-raisin.co.uk/kcps/api/v1',
      onboarding: 'https://api2.onboarding-raisin.co.uk/kcps/api/v1',
      production: 'https://api2.raisin.co.uk/kcps/api/v1',
    },
    deu: {
      local: 'https://api2.dev-weltsparen.de/kcps/api/v1',
      development: 'https://api2.dev-weltsparen.de/kcps/api/v1',
      staging: 'https://api2.staging-weltsparen.de/kcps/api/v1',
      onboarding: 'https://api2.onboarding-weltsparen.de/kcps/api/v1',
      production: 'https://api2.weltsparen.de/kcps/api/v1',
    },
  },
  psdc: {
    gbr: {
      local: 'https://api2.dev-raisin.co.uk/psdc/v1/public',
      development: 'https://api2.dev-raisin.co.uk/psdc/v1/public',
      staging: 'https://api2.staging-raisin.co.uk/psdc/v1/public',
      onboarding: 'https://api2.onboarding-raisin.co.uk/psdc/v1/public',
      production: 'https://api2.raisin.co.uk/psdc/v1/public',
    },
  },
  ctms: {
    gbr: {
      local: 'https://api2.dev-raisin.co.uk/ctms/v1/public',
      development: 'https://api2.dev-raisin.co.uk/ctms/v1/public',
      staging: 'https://api2.staging-raisin.co.uk/ctms/v1/public',
      onboarding: 'https://api2.onboarding-raisin.co.uk/ctms/v1/public',
      production: 'https://api2.raisin.co.uk/ctms/v1/public',
    },
    deu: {
      local: 'https://api2.dev-weltsparen.de/ctms/v1/public',
      development: 'https://api2.dev-weltsparen.de/ctms/v1/public',
      staging: 'https://api2.staging-weltsparen.de/ctms/v1/public',
      onboarding: 'https://api2.onboarding-weltsparen.de/ctms/v1/public',
      production: 'https://api2.weltsparen.de/ctms/v1/public',
    },
  },
  dbs: {
    gbr: {
      local: 'https://api2.dev-raisin.co.uk/dbs/v1',
      development: 'https://api2.dev-raisin.co.uk/dbs/v1',
      staging: 'https://api2.staging-raisin.co.uk/dbs/v1',
      onboarding: 'https://api2.onboarding-raisin.co.uk/dbs/v1',
      production: 'https://api2.raisin.co.uk/dbs/v1',
    },
    deu: {
      local: 'https://api2.dev-weltsparen.de/dbs/v1',
      development: 'https://api2.dev-weltsparen.de/dbs/v1',
      staging: 'https://api2.staging-weltsparen.de/dbs/v1',
      onboarding: 'https://api2.onboarding-weltsparen.de/dbs/v1',
      production: 'https://api2.weltsparen.de/dbs/v1',
    },
  },
  das: {
    gbr: {
      local: 'https://api2.dev-raisin.co.uk/das/v1',
      development: 'https://api2.dev-raisin.co.uk/das/v1',
      staging: 'https://api2.staging-raisin.co.uk/das/v1',
      onboarding: 'https://api2.onboarding-raisin.co.uk/das/v1',
      production: 'https://api2.raisin.co.uk/das/v1',
    },
    deu: {
      local: 'https://api2.dev-weltsparen.de/das/v1',
      development: 'https://api2.dev-weltsparen.de/das/v1',
      staging: 'https://api2.staging-weltsparen.de/das/v1',
      onboarding: 'https://api2.onboarding-weltsparen.de/das/v1',
      production: 'https://api2.weltsparen.de/das/v1',
    },
  },
  ddoc: {
    gbr: {
      local: 'https://api2.dev-raisin.co.uk/ddoc/public/api/v1',
      development: 'https://api2.dev-raisin.co.uk/ddoc/public/api/v1',
      staging: 'https://api2.staging-raisin.co.uk/ddoc/public/api/v1',
      onboarding: 'https://api2.onboarding-raisin.co.uk/ddoc/api/v1',
      production: 'https://api2.raisin.co.uk/ddoc/api/v1',
    },
    deu: {
      local: 'https://api2.dev-weltsparen.de/ddoc/api/v1',
      development: 'https://api2.dev-weltsparen.de/ddoc/api/v1',
      staging: 'https://api2.staging-weltsparen.de/ddoc/api/v1',
      onboarding: 'https://api2.onboarding-weltsparen.de/ddoc/api/v1',
      production: 'https://api2.weltsparen.de/ddoc/api/v1',
    },
  },
  ddocpublic: {
    gbr: {
      local: 'https://api2.dev-raisin.co.uk/ddoc/public/api/v1',
      development: 'https://api2.dev-raisin.co.uk/ddoc/public/api/v1',
      staging: 'https://api2.staging-raisin.co.uk/ddoc/public/api/v1',
      onboarding: 'https://api2.onboarding-raisin.co.uk/ddoc/public/api/v1',
      production: 'https://api2.raisin.co.uk/ddoc/public/api/v1',
    },
    deu: {
      local: 'https://api2.dev-weltsparen.de/ddoc/public/api/v1',
      development: 'https://api2.dev-weltsparen.de/ddoc/public/api/v1',
      staging: 'https://api2.staging-weltsparen.de/ddoc/public/api/v1',
      onboarding: 'https://api2.onboarding-weltsparen.de/ddoc/public/api/v1',
      production: 'https://api2.weltsparen.de/ddoc/public/api/v1',
    },
  },
  dts: {
    gbr: {
      local: 'https://api2.dev-raisin.co.uk/dts/api/v2',
      development: 'https://api2.dev-raisin.co.uk/dts/api/v2',
      staging: 'https://api2.staging-raisin.co.uk/dts/api/v2',
      onboarding: 'https://api2.onboarding-raisin.co.uk/dts/api/v2',
      production: 'https://api2.raisin.co.uk/dts/api/v2',
    },
    deu: {
      local: 'https://api2.dev-weltsparen.de/dts/api/v2',
      development: 'https://api2.dev-weltsparen.de/dts/api/v2',
      staging: 'https://api2.staging-weltsparen.de/dts/api/v2',
      onboarding: 'https://api2.onboarding-weltsparen.de/dts/api/v2',
      production: 'https://api2.weltsparen.de/dts/api/v2',
    },
  },
  dts_public: {
    gbr: {
      local: 'https://api2.dev-raisin.co.uk/dts/public/api/v2',
      development: 'https://api2.dev-raisin.co.uk/dts/public/api/v2',
      staging: 'https://api2.staging-raisin.co.uk/dts/public/api/v2',
      onboarding: 'https://api2.onboarding-raisin.co.uk/dts/public/api/v2',
      production: 'https://api2.raisin.co.uk/dts/public/api/v2',
    },
    deu: {
      local: 'https://api2.dev-weltsparen.de/dts/public/api/v2',
      development: 'https://api2.dev-weltsparen.de/dts/public/api/v2',
      staging: 'https://api2.staging-weltsparen.de/dts/public/api/v2',
      onboarding: 'https://api2.onboarding-weltsparen.de/dts/public/api/v2',
      production: 'https://api2.weltsparen.de/dts/public/api/v2',
    },
  },
};

module.exports.microservices = microservices;
